export const todayLA = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles' }).format(new Date());

export const addDays = (iso, n) => {
  const d = new Date(`${iso}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

export const daysBetween = (a, b) => Math.round((Date.parse(`${b}T12:00:00Z`) - Date.parse(`${a}T12:00:00Z`)) / 86400000) + 1;

export const PRESETS = [
  { value: '7d', label: '7 days', days: 7, group: 'day' },
  { value: '30d', label: '30 days', days: 30, group: 'day' },
  { value: '90d', label: '90 days', days: 90, group: 'week' },
  { value: '12m', label: '12 months', days: 365, group: 'month' },
  { value: 'ytd', label: 'Year to date', group: 'month' },
  { value: 'custom', label: 'Custom' },
];

export const presetRange = (value) => {
  const end = todayLA();
  const p = PRESETS.find(x => x.value === value);
  if (value === 'ytd') return { start: `${end.slice(0, 4)}-01-01`, end, group: 'month' };
  return { start: addDays(end, -(p.days - 1)), end, group: p.group };
};

export const previousRange = (start, end) => {
  const n = daysBetween(start, end);
  const pEnd = addDays(start, -1);
  return { start: addDays(pEnd, -(n - 1)), end: pEnd };
};

export const money = (cents) => `${cents < 0 ? '-' : ''}$${(Math.abs(cents) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const change = (cur, old) => {
  if (old === 0) return cur === 0 ? 'Same as previous period' : 'Previous period: none';
  const pct = ((cur - old) / Math.abs(old)) * 100;
  return `${pct > 0 ? '+' : ''}${pct.toFixed(1)}% vs previous period`;
};
